import React from "react";
import AppIcon from "./AppIcon.jsx";

const appStep = (props) => {
  const {
    active,
    completed = false,
    icon,
    title,
    description,
    activeKey,
    onActive,
    isLast,
    disabled = false,
  } = props;
  const isPrimary = active || completed;

  return (
    <div
      className={`app-step flex items-start gap-4 ${
        disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
      }`}
      onClick={() => {
        if (!disabled) onActive(activeKey);
      }}
    >
      {/* Left Icon + optional connector to next step */}
      <div className="app-step-rail flex shrink-0 flex-col items-center">
        <div
          className={`app-step-icon flex h-10 w-10 items-center justify-center rounded-lg border ${
            isPrimary ? "border-primary" : "border-gray-300"
          }`}
        >
          <AppIcon
            name={icon}
            className={isPrimary ? "text-primary" : "text-gray-500"}
          />
        </div>
        {!isLast ? (
          <div
            className={`mt-1 h-10 w-px shrink-0 ${completed ? "bg-primary" : "bg-gray-600"}`}
            aria-hidden
          />
        ) : null}
      </div>

      {/* Text Content */}
      <div className="app-step-text">
        <h3 className={`text-sm font-semibold ${isPrimary ? "text-primary" : "text-gray-900"}`}>{title}</h3>
        <p className="mt-1 max-w-xs text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
};

export default appStep;
